//GenerateThink5whysCodeSignup.js

// Important: Ths GenerateThink5WhysCode also getting generated in GenerateThink5WhysCodeSignup.jsx
const GenerateThink5whysCodeSignup = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
    const prefix = 'TU';

    return `${prefix}${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

const getYearCode = (year) => {
    const lastTwoDigits = year.toString().slice(-2);
    return lastTwoDigits;
};

const getMonthCode = (month) => {
    if (month >= 1 && month <= 9) {
        return month.toString();
    } else {
        return String.fromCharCode(64 + month - 9); // A = 10, B = 11, ...
    }
};

const getDayCode = (day) => {
    if (day >= 1 && day <= 9) {
        return day.toString();
    } else {
        return String.fromCharCode(64 + day - 9); // A = 10, B = 11, ...
    }
};

const getHourCode = (hour) => {
    if (hour >= 1 && hour <= 9) {
        return hour.toString();
    } else {
        return String.fromCharCode(64 + hour - 9); // A = 10, B = 11, ...
    }
};

export { GenerateThink5whysCodeSignup, };